import React from 'react'
import GridItem from "components/Grid/GridItem.js";
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
  }
}))

function BlankSpace(props){
  const classes = useStyles()
  const fieldsize = props.fieldsize ? props.fieldsize : 12
  const xs = props.xs ? props.xs : 12
  const sm = props.sm ? props.sm : 12
  const height = props.height ? props.height : 20

  return(
    <GridItem direction={props.direction} xs={xs} sm={sm} md={fieldsize}>
      <div className={classes.root} style={{height: height}}>
        {props.children}
     </div>
    </GridItem>
  )
}
export default BlankSpace
